<template>
  <d2-container>
    <el-form :model="form" :rules="rules" ref="form" label-width="200px">
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" placeholder="输入名称" :clearable="true"></el-input>
      </el-form-item>
      <el-form-item label="介绍" prop="title">
        <el-input
                  v-model="form.introduce"
                  :autosize="{ minRows: 2, maxRows: 10}"
                  type="textarea"
                  placeholder="输入内容"
        />
      </el-form-item>
      <!--  消息内容    -->

      <el-form-item>
        <div style="border:1px solid #DCDFE6;padding:0 0 20px 0;margin-bottom: 20px;">
          <div
              style="text-align: center;color: #909399;width: 99%;margin: 2px auto;margin-bottom: 24px; "
          >问卷问题</div>
          <div  v-for="(item, index) in form.elements" :key="index">
            <el-alert :title=" '问题.' + (index + 1) + ' ' + item.name" style="margin: 10px;" type="info" :closable="false" />
            <el-form label-width="200px" size="small">

              <el-form-item label="问题名称" prop="name">
                <el-input v-model="item.name" placeholder="输入名称" :clearable="true"></el-input>
              </el-form-item>
              <el-form-item label="排序" required>
                <el-input-number v-model="item.sort" :min="0" :max="999" />
              </el-form-item>
              <el-form-item label="消息类型">
                <el-radio-group v-model="item.contentType">
                  <el-radio :label="0">文字</el-radio>
                  <el-radio :label="1">语音</el-radio>
                  <el-radio :label="2">图片</el-radio>
                  <el-radio :label="3">视频</el-radio>
                </el-radio-group>
              </el-form-item >
              <el-form-item label="内容">
                <el-input v-if="item.contentType === 0"
                          v-model="item.content"
                          :autosize="{ minRows: 2, maxRows: 10}"
                          type="textarea"
                          placeholder="输入内容"
                />
                <uploadVideo   v-if="item.contentType === 3" v-model="item.content" :text="['视频大小500m以内', '视频格式mp4']"></uploadVideo>
                <upload-audio   v-if="item.contentType === 1" v-model="item.content" :text="['音频文件100M以内', '视频格式mp3']"></upload-audio>
                <upload-img v-if="item.contentType === 2" v-model="item.content" :imgSize="1" :text="['图片大小5M以内', '图片格式png/jpg/gif']"></upload-img>
              </el-form-item>

              <el-form-item label="可多选">
                <el-switch
                    v-model="item.multipleChoice"
                    :active-value="1"
                    :inactive-value="0"
                    active-text="开启"
                    inactive-text="关闭">
                </el-switch>
              </el-form-item>

              <el-form-item label="问题选项">
                <el-form
                    v-for="(choice, choiceIdx) in item.choices"
                    :key="choiceIdx"
                    label-width="200px"
                    size="small">
                  <el-form-item label="选项名称" prop="name">
                    <el-input v-model="choice.name" placeholder="输入名称" :clearable="true"></el-input>
                  </el-form-item>
                  <el-form-item label="可得分数" required>
                    <el-input-number v-model="choice.score" :min="0" :max="999" />
                  </el-form-item>

                  <el-form-item>
                    <div style="display: flex;justify-content: center;margin-top: 14px;">
                      <el-button
                          type="danger"
                          size="mini"
                          @click="removeChoice(index, choiceIdx)"
                          v-if="choiceIdx !== 0"
                      >-删除选项</el-button>
                    </div>
                  </el-form-item>
                </el-form>
                <div style="display: flex;justify-content: center;margin-bottom: 14px;margin-top: 14px;">
                  <el-button type="primary" size="mini" @click="addChoice(index)">+增加选项</el-button>
                </div>
              </el-form-item>
              <el-form-item>
                <div style="display: flex;justify-content: center;margin-top: 14px;">
                  <el-button
                      type="danger"
                      size="mini"
                      @click="removeList(index)"
                      v-if="index !== 0"
                  >-删除[{{item.name}}]</el-button>
                </div>
              </el-form-item>
            </el-form>

          </div>
          <div style="display: flex;justify-content: center;margin-bottom: 14px;margin-top: 14px;">
            <el-button type="primary" size="mini" @click="addList">+增加问题</el-button>
          </div>
        </div>
      </el-form-item>

      <el-form-item>
        <div style="border:1px solid #DCDFE6;padding:0 0 20px 0;margin-bottom: 20px;">
          <div
              style="text-align: center;color: #909399;width: 99%;margin: 2px auto;margin-bottom: 24px; "
          >问卷报告</div>
          <div  v-for="(item, index) in form.resList" :key="index">
            <el-alert :title=" '报告.' + (index + 1) + ' ' + item.name" style="margin: 10px;" type="info" :closable="false" />
            <el-form label-width="200px" size="small">
              <el-form-item label="报告名称" prop="name">
                <el-input v-model="item.name" placeholder="输入名称" :clearable="true"></el-input>
              </el-form-item>
              <el-form-item label="累计总分" required>
                <el-input-number v-model="item.score" :min="0" :max="9999999" />
              </el-form-item>
              <el-form-item label="类型">
                <el-radio-group v-model="item.type">
                  <el-radio :label="0">文字</el-radio>
                  <el-radio :label="1">海报</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="内容">

                <el-input v-if="item.type === 0"
                          v-model="item.content"
                          :autosize="{ minRows: 2, maxRows: 10}"
                          type="textarea"
                          placeholder="输入内容"
                />
                <el-select
                    v-if="item.type === 1"
                    v-model="item.content"
                    filterable
                    reserve-keyword
                    placeholder="搜素内容集"
                    :loading="replyOptionLoading"
                >
                  <el-option
                      v-for="option in posterList"
                      :key="option.id"
                      :label="option.name"
                      :value="option.id"
                  />
                </el-select>
              </el-form-item>

              <el-form-item label="衔接内容">
                <el-select
                    v-model="item.keywordId"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="搜素内容集"
                    :remote-method="getKeywordList"
                    :loading="replyOptionLoading"
                >
                  <el-option
                      v-for="option in keywordList"
                      :key="option.key"
                      :label="option.value"
                      :value="option.key"
                  />
                </el-select>
              </el-form-item>
              <el-form-item>
                <div style="display: flex;justify-content: center;margin-top: 14px;">
                  <el-button
                      type="danger"
                      size="mini"
                      @click="removeResList(index)"
                      v-if="index !== 0"
                  >-删除报告</el-button>
                </div>
              </el-form-item>
            </el-form>

          </div>
          <div style="display: flex;justify-content: center;margin-bottom: 14px;margin-top: 14px;">
            <el-button type="primary" size="mini" @click="addResList">+增加报告</el-button>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button @click="$router.back()">取 消</el-button>
      <el-button type="success" @click="confirm('form')">确定</el-button>
    </div>
  </d2-container>
</template>
<script>
import {
  addQuestionnaire,
  updateQuestionnaire,
  getQuestionnaireInfo,
  replyContentOption,
  replyKeywordOption
} from '@/api/demo/helper/index'
import {
  getClockInOptions
} from '@/api/demo/punchInActivity/index'
import { getPosterList } from '@/api/demo/poster/index'
import { getToken } from '@/api/demo/classification/index'
import uploadVideo from '@/components/uploadVideo/index.vue'
import uploadAudio from '@/components/uploadAudio/index.vue'
import UploadImg from '@/components/uploadImage/index.vue'
import jumpType2 from '@/components/jumpType/jumpType'
export default {
  components: {
    jumpType2,
    uploadVideo,
    uploadAudio,
    UploadImg
  },
  name: 'editQuestionnaireContent',
  data () {
    return {
      jumpContent: {
        url: null,
        id: null,
        classId: null,
        paramType: '0',
        value: '',
        icon: ''
      },

      keywordList: [],
      posterList: [],
      id: null, // id
      form: {
        introduce: '', // 介绍
        name: '', // 活动名称
        elements: [ // 菜单选项
          {
            id: null,
            choices: [ // 选项
              {
                id: null,
                name: '', // 名称
                score: 0 // 分数
              }
            ],
            name: '',
            contentType: 0, // 问题类型 0.文字 1.语音 2.图片 3.视频 4.跳转
            content: '',
            multipleChoice: 0, // 是否多选
            sort: 1 // 序号
          }
        ],
        resList: [{ // 结果
          id: null,
          name: '',
          score: 0,
          type: 0,
          content: '',
          keywordId: null
        }]
      },
      replyOptionLoading: false,
      rules: {
        keyword: [
          {
            required: true,
            message: '请输入关键词',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 200,
            message: '长度在 1 到 200 个字符',
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 50,
            message: '长度在 1 到 50 个字符',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    let that = this
    that.id = that.$route.query.id
    if (that.id != null) {
      that.getInfo(that.id)
    }
    that.getKeywordList()
    that.getPosterList()
  },
  methods: {
    removeChoice (elementIdx, choiceIdx) {
      this.form.elements[elementIdx].choices.splice(choiceIdx, 1)
      this.form.elements.forEach((item, index) => {
        item.index = index
      })
    },
    addChoice (elementIdx) {
      this.form.elements[elementIdx].choices.push({
        id: null,
        name: '', // 名称
        score: 0 // 分数
      })
    },
    removeList (index) {
      this.form.elements.splice(index, 1)
      this.form.elements.forEach((item, index) => {
        item.index = index
      })
    },
    addList () {
      this.form.elements.push({
        id: null,
        choices: [ // 选项
          {
            id: null,
            name: '', // 名称
            score: 0 // 分数
          }
        ],
        name: '',
        contentType: 0, // 问题类型 0.文字 1.语音 2.图片 3.视频 4.跳转
        content: '',
        multipleChoice: 0, // 是否多选
        sort: this.form.elements[this.form.elements.length - 1].sort + 1 // 序号
      })
    },
    removeResList (index) {
      this.form.resList.splice(index, 1)
      this.form.resList.forEach((item, index) => {
        item.index = index
      })
    },
    addResList () {
      this.form.resList.push({ // 结果
        id: null,
        name: '',
        score: 0,
        type: 0,
        content: '',
        keywordId: null
      })
    },
    getPosterList () {
      let that = this
      getPosterList({ currentPage: 1,
        pageSize: 200 }).then(res => {
        that.posterList = res.records
      })
    },
    getKeywordList (keyword) {
      let that = this
      let query = { 'keyword': keyword }
      that.replyOptionLoading = true
      replyKeywordOption(query).then(res => {
        that.keywordList = res
      }).finally(() => {
        that.replyOptionLoading = false
      })
    },
    getInfo (id) {
      let that = this
      getQuestionnaireInfo(id).then(res => {
        that.form = res
      })
    },
    confirm () {
      if (this.id) {
        this.getModify('form')
      } else {
        this.getCreate('form')
      }
    },
    // 新增
    getCreate (forms) {
      let that = this
      that.$refs[forms].validate(valid => {
        addQuestionnaire(that.form).then(res => {
          that.$notify({
            title: '成功',
            message: '新增成功',
            type: 'success',
            duration: 2000
          })
          that.$router.back()
        })
      })
    },
    // 编辑
    getModify (forms) {
      let that = this
      that.$refs[forms].validate(valid => {
        updateQuestionnaire(that.id, that.form).then(res => {
          that.$notify({
            title: '成功',
            message: '修改成功',
            type: 'success',
            duration: 2000
          })
          that.$router.back()
        })
      })
    }
  },
  mounted () {
  }
}
</script>
<style scoped>
/deep/.el-input-number {
  margin-right: 12px;
}
.footer {
  text-align: center;
  margin-top: 20px;
}
</style>
